import React, { useEffect, useRef, useCallback, useState } from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/dofy.png";
import { withTranslation } from "react-i18next";
import withRouter from "../../components/Common/withRouter";
import CommonService from "services/CommonService";
import { IDashboardStats } from "models/DashboardStats.Model";
import { aes_decryption, getLocalStorage, isMobile } from "../../helpers/Helper";

import { getDecodedAccessToken } from "../../helpers/TokenHelper";
import { useTypedDispatch, useTypedSelector } from "features/reduxhooks/ReduxHooks";
import { FilterDataId } from "features/reducers/filterdata/FilterData.Reducers";

const SidebarContent = (props: any) => {
  const ref = useRef<any>();
  const dispatch: any = useTypedDispatch();
  let navigate = useNavigate();
  const activateParentDropdown = useCallback((item: any) => {
    const links = document.querySelectorAll("#side-menu a");
    links.forEach((link) => link.classList.remove("menu-item-active"));
    item.classList.add("menu-item-active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("menu-item-active")) {
        item.classList.remove("menu-item-active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };
  const [isToday, setIsToday] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [DashboardStats, setDashboardStats] = useState<IDashboardStats>();
  const [userMenuList, setUserMenuList] = useState<Array<any>>([]);

  let FromDate = useTypedSelector(state => state.FilterDataReducers.FromDate);
  let ToDate = useTypedSelector(state => state.FilterDataReducers.ToDate);

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul: any = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (
        items[i].getAttribute("href") === pathName ||
        items[i].getAttribute("to") === pathName
      ) {
        const menuTitle = items[i].querySelector("span")?.textContent;
        // Skip "Report" menu
        if (menuTitle !== "Report") {
          matchingMenuItem = items[i];
          break;
        }
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    } else {
      // Fallback to dynamic menu matching
      Object.values(userMenuList).forEach((menuItem: any) => {
        if (menuItem.Path && `${process.env.PUBLIC_URL}${menuItem.Path}` === pathName) {
          const dynamicItem = ul.querySelector(`a[href="${menuItem.Path}"]`);
          if (dynamicItem) {
            const menuTitle = dynamicItem.querySelector("span")?.textContent;
            if (menuTitle !== "Report") {
              matchingMenuItem = dynamicItem;
              activateParentDropdown(matchingMenuItem);
            }
          }
        }
      });
    }
  }, [props.router.location.pathname, activateParentDropdown, userMenuList]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);



  const checkIsToday = (dateString: string) => {
    const today = new Date();
    const formattedToday = today.toISOString().slice(0, 10);
    return dateString === formattedToday;
  };

  useEffect(() => {
    const formattedFromDate = new Date(FromDate).toISOString().slice(0, 10);
    const date = checkIsToday(formattedFromDate);
    setIsToday(date);
  }, [FromDate]);

  const getUserMenuList = () => {
    const PersonId = getDecodedAccessToken(getLocalStorage().Token)?.PersonId;
    debugger
    CommonService.getWithSingleEntity("personModel", "GetMenuAccess", 0).then(res => {
      if (res.status === 200) {
        const decryptedData = aes_decryption(res.data);
        const menuData = JSON.parse(decryptedData);
        setUserMenuList(menuData);
      }
    }).catch((e) => {
      if (e === "Request failed with status code 401") {
        navigate("/logout");
      } else {
        console.error("API error:", e);
      }
      setShowLoading(false);
    });
  };

  useEffect(() => {
    if (getLocalStorage().Token) {
      getUserMenuList();
    }
  }, []);

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const groupedMenuList = userMenuList.reduce((acc: any, menuItem: any) => {
    if (!acc[menuItem.ScreenTypeName]) {
      acc[menuItem.ScreenTypeName] = [];
    }
    acc[menuItem.ScreenTypeName].push(menuItem);
    return acc;
  }, {});

  const reset = () => {
    let today = new Date();
    let priorDate = new Date(new Date().setDate(today.getDate() - 90));

    dispatch(FilterDataId({ payload: null, type: "CityName" }));
    dispatch(FilterDataId({ payload: null, type: "RiderName" }));
    dispatch(FilterDataId({ payload: null, type: "PromoCodeName" }));
    dispatch(FilterDataId({ payload: null, type: "ProductName" }));
    dispatch(FilterDataId({ payload: null, type: "ModalName" }));
    dispatch(FilterDataId({ payload: null, type: "BrandName" }));
    dispatch(FilterDataId({ payload: null, type: "CityId" }));
    dispatch(FilterDataId({ payload: null, type: "RiderId" }));
    dispatch(FilterDataId({ payload: 0, type: "ProductId" }));
    dispatch(FilterDataId({ payload: null, type: "BrandId" }));
    dispatch(FilterDataId({ payload: null, type: "ModelId" }));
    dispatch(FilterDataId({ payload: "", type: "PromoCode" }));
    dispatch(FilterDataId({ payload: priorDate, type: "FromDate" }));
    dispatch(FilterDataId({ payload: null, type: "ToDate" }));
    dispatch(FilterDataId({ payload: priorDate, type: "CompletedStartDate" }));
    dispatch(FilterDataId({ payload: null, type: "CompletedEndDate" }));
  };

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        {isMobile() && (
          <div className="logo-sm text-center my-4">
            <img src={logo} alt="" height="30" />
          </div>
        )}
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {Object.keys(groupedMenuList).map((typeName: string) => (
              <li key={typeName} onClick={props.toggleCanvas}>
                {groupedMenuList[typeName]
                  .filter((item: any) => item.ActivityMasterId === 1 && item.HasAccess === true
                    && !(isMobile() && (typeName.toLowerCase() === "import" || typeName.toLowerCase() === "import history")))
                  .filter((x, i) => groupedMenuList[typeName].indexOf(x) === i)
                  .map((items: any) => (
                    <Link
                      key={items.ScreenMasterId}
                      to={
                        typeName === "Orders"
                          ? "/homepage"
                          : groupedMenuList[typeName].some((item: any) => item.IsHaveSubMenu)
                            ? "#"
                            : items.Path
                      }
                      className={
                        groupedMenuList[typeName].some((item: any) => item.IsHaveSubMenu) &&
                          typeName !== "Orders"
                          ? "has-arrow"
                          : ""
                      }
                    >
                      <i
                        className={`${items.Icon} ${props.router.location.pathname === items.Path ? "text-white" : ""
                          }`}
                      ></i>
                      <span>{props.t(typeName)}</span>
                    </Link>
                  ))}
                {typeName !== "Orders" && groupedMenuList[typeName].some((item: any) => item.IsHaveSubMenu === true) && (
                  <ul className="sub-menu" onClick={props.toggleCanvas}>
                    {groupedMenuList[typeName]
                      .filter((item: any) => item.ActivityMasterId === 1 && item.HasAccess === true)
                      .map((filteredItem: any) => (
                        <li key={filteredItem.ScreenMasterId} onClick={() => filteredItem.ScreenTypeName === "Orders" && reset()}>
                          <Link to={filteredItem.Path ? filteredItem.Path : "#"} className={props.router.location.pathname === filteredItem.Path ? "menu-item-active" : ""}>
                            <i className={filteredItem.SubMenuIcons}></i>
                            <span>{props.t(filteredItem.Title)}</span>
                            {/* {DashboardStats && (
                              <Badge color="info" className="me-1 p-1 px-1 font-size-8 rounded-2">
                                {DashboardStats[filteredItem.ScreenName]}
                              </Badge>
                            )} */}
                          </Link>
                        </li>
                      ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(SidebarContent));